import { Record } from 'immutable';
import remove from 'lodash/fp/remove';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  forms: [],
  form: {
    id: null,
    dealer_id: null,
  },
  printed_forms: [],
  [constants.ERROR_KEY]: null,
  [constants.SUCCESS_KEY]: null,
  [constants.FETCHING_KEY]: false,
});

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.PRINTED_FORMS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('printed_forms', payload);
    case types.FORMS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('forms', payload);
    case types.FORM_SUCCESS:
    case types.CREATE_FORM_SUCCESS:
    case types.UPDATE_FORM_SUCCESS:
    case types.EDIT_FORM_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('form', payload);
    case types.DELETE_FORM_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('forms', remove({ id: payload })(state.forms));
    case types.PRINTED_FORMS_REQUEST:
    case types.FORMS_REQUEST:
    case types.FORM_REQUEST:
    case types.CREATE_FORM_REQUEST:
    case types.UPDATE_FORM_REQUEST:
    case types.EDIT_FORM_REQUEST:
    case types.DELETE_FORM_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.PRINTED_FORMS_FAILURE:
    case types.FORMS_FAILURE:
    case types.FORM_FAILURE:
    case types.CREATE_FORM_FAILURE:
    case types.UPDATE_FORM_FAILURE:
    case types.EDIT_FORM_FAILURE:
    case types.DELETE_FORM_FAILURE:
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.ERROR_KEY, action.payload);
    case types.RESET_FORM:
      return state.set('form', {
        ...requestReducerState().form,
        dealer_id: action.payload,
      });
    default:
      return state;
  }
};
